import { z } from 'zod';
/**
 * The API's stable error vocabulary, mirroring `src/shared/errors/app-error.ts`.
 *
 * Clients branch on these codes and never on `message` — messages are written
 * to be shown to people and get reworded; codes are the contract.
 */
export const API_ERROR_CODES = [
    'VALIDATION_ERROR',
    'UNAUTHORIZED',
    'FORBIDDEN',
    'PREMIUM_REQUIRED',
    'NOT_FOUND',
    'CONFLICT',
    'GONE',
    'UNPROCESSABLE',
    'RATE_LIMITED',
    'INTERNAL_ERROR',
    'UPSTREAM_UNAVAILABLE',
];
export const apiErrorCodeSchema = z.enum(API_ERROR_CODES);
/** HTTP status each code is served with. Asserted against the API in its own suite. */
export const HTTP_STATUS_BY_CODE = {
    VALIDATION_ERROR: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    PREMIUM_REQUIRED: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    GONE: 410,
    UNPROCESSABLE: 422,
    RATE_LIMITED: 429,
    INTERNAL_ERROR: 500,
    UPSTREAM_UNAVAILABLE: 503,
};
/**
 * Sets rather than arrays: these are consulted on every failed request, and a
 * membership test should not walk a list.
 */
const RETRYABLE_CODES = new Set(['RATE_LIMITED', 'UPSTREAM_UNAVAILABLE']);
/**
 * Worth trying again unchanged. `INTERNAL_ERROR` is deliberately absent — a 500
 * means the server broke, and hammering it is not a recovery strategy.
 */
export function isRetryable(code) {
    return RETRYABLE_CODES.has(code);
}
/**
 * The token is stale or absent. The client refreshes once and retries; only a
 * second failure signs the admin out. Never triggered by `FORBIDDEN`, which
 * means the credential was fine and the role was not — signing out on that
 * would loop a `support` user through the login screen forever.
 */
export function requiresReauth(code) {
    return code === 'UNAUTHORIZED';
}
/** An unrecognised code from a newer server is not retryable and not fatal. */
export function isKnownErrorCode(code) {
    return apiErrorCodeSchema.safeParse(code).success;
}
//# sourceMappingURL=errors.js.map